var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMulti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communities-Page",
    transform: "translate(-1106.000000, -581.000000)",
    fill: "#FA7319",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communities-Copy",
    transform: "translate(1035.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(12.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59,17.8769231 L60.3333333,17.8769231 L60.3333333,16.5846154 L59,16.5846154 L59,17.8769231 Z M59,20.4615385 L60.3333333,20.4615385 L60.3333333,19.1692308 L59,19.1692308 L59,20.4615385 Z M59,15.2923077 L60.3333333,15.2923077 L60.3333333,14 L59,14 L59,15.2923077 Z M61.6666667,17.8769231 L71,17.8769231 L71,16.5846154 L61.6666667,16.5846154 L61.6666667,17.8769231 Z M61.6666667,20.4615385 L71,20.4615385 L71,19.1692308 L61.6666667,19.1692308 L61.6666667,20.4615385 Z M61.6666667,14 L61.6666667,15.2923077 L71,15.2923077 L71,14 L61.6666667,14 Z",
    id: "Shape-Copy-2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti);
export default __webpack_public_path__ + "static/media/multi.67e768e1f9bdb5291f20c3fe3a751d65.svg";
export { ForwardRef as ReactComponent };